export default __webpack_public_path__ + "static/media/chubb-color.1b77bd09.svg";